export const lt = {
  message: {
    overtime: {
      title: 'Viršvalandžiai',
      from: 'Nuo',
      to: 'Iki',
      fifty: 'Viršvalandžiai 50%',
      hundred: 'Viršvalandžiai 100%',
      total: 'Iš viso',
      entries: 'Įrašai',
      noEntries: 'Šiuo laikotarpiu viršvalandžių nėra.'
    },
    egenmelding: {
      title: 'Savideklaracija',
      report: 'Pateikti savideklaraciją',
      type: 'Tipas',
      own: 'Sava liga',
      child: 'Sergantis vaikas',
      startDate: 'Nuo datos',
      days: 'Dienos',
      instances: 'atvejai',
      remaining: 'Liko',
      exhausted: 'Kvota išnaudota',
      ownDaysHint: 'Daugiausia 3 kalendorinės dienos vienam atvejui',
      send: 'Pateikti',
      reported: 'Savideklaracija pateikta',
      quotaExceeded: 'Tai viršytų likusią kvotą',
      tooManyDays: 'Viršija likusias dienas'
    },
    flex: {
      title: 'Lankstusis laikas',
      balance: 'Lanksčiojo laiko likutis',
      asOf: 'Data',
      policy: 'Taisyklės',
      transactions: 'Operacijos',
      transactionHistory: 'Operacijų istorija',
      noTransactions: 'Operacijų dar nėra.',
      avspasering: 'Atostogos už viršvalandžius',
      requestAvspasering: 'Prašyti laisvo laiko',
      myRequests: 'Mano prašymai',
      noRequests: 'Prašymų dar nėra.',
      startDate: 'Data nuo',
      endDate: 'Data iki',
      hours: 'Valandos',
      minutes: 'Minutės',
      comment: 'Komentaras',
      date: 'Data',
      type: 'Tipas',
      change: 'Pokytis',
      submit: 'Pateikti prašymą',
      cancelRequest: 'Atšaukti prašymą',
      confirmCancel: 'Ar atšaukti šį prašymą?',
      requestSubmitted: 'Prašymas pateiktas!',
      requestCancelled: 'Prašymas atšauktas.',
      overtimeRegistered: 'Viršvalandžiai užregistruoti',
      overtime: 'Viršvalandžiai',
      toFlexAccount: 'Į lankstųjį kontą (pagrindinės valandos)',
      paidSupplement: 'Išmokėtas priedas',
      sendToFlex: 'Siųsti į lankstųjį kontą',
      payOut: 'Išmokėti',
      decideLater: 'Nuspręsti vėliau',
      decideNow: 'Nuspręsti dabar',
      flexChoice: 'Lanksčiojo laiko pasirinkimas',
      choiceSaved: 'Pasirinkimas išsaugotas.',
      noPendingLines: 'Nėra laukiančių viršvalandžių, dėl kurių reikia nuspręsti.',
      choice: {
        pending: 'Laukiama',
        flex: 'Lankstusis kontas',
        payout: 'Išmokėta'
      },
      state: {
        pending: 'Laukiama',
        approved: 'Patvirtinta',
        denied: 'Atmesta',
        cancelled: 'Atšaukta'
      },
      txType: {
        accrual: 'Sukaupimas',
        withdrawal_avspasering: 'Laisvas laikas',
        cap_excess_to_overtime: 'Viršija ribą → viršvalandžiai',
        cap_excess_dropped: 'Viršija ribą → panaikinta',
        rollover: 'Perkelta',
        payout: 'Išmokėta',
        expire: 'Nebegalioja',
        adjustment_manual: 'Rankinis koregavimas'
      }
    },
    dashboard: {
      edit: 'Redaguoti',
      done: 'Atlikta',
      reset: 'Atstatyti',
      theme: 'Tema',
      darkMode: 'Tamsus režimas',
      featured: 'Išskirta',
      allModules: 'Visi moduliai',
      dragToFeature: 'Vilkite modulius čia, kad juos išskirtumėte',
      editHint: 'Vilkite, kad pertvarkytumėte · pakeitimai išsaugomi automatiškai',
      editHintFeatured: 'Vilkite modulį aukštyn, kad išskirtumėte · vilkite žemyn, kad pašalintumėte',
      editHintBento: 'Vilkite, kad pertvarkytumėte · palieskite ⤢, kad pakeistumėte dydį · išsaugoma automatiškai',
      layoutTiles: 'Plytelės',
      layoutSections: 'Skiltys',
      layoutBento: 'Bento',
      sectionWork: 'Darbas',
      sectionResources: 'Ištekliai',
      sectionInfoMore: 'Informacija ir daugiau',
      modules: 'Moduliai',
      customizeModules: 'Tinkinti modulius'
    },
    layout: {
      login: 'Prisijungimas',
      ortext: 'ARBA',
      logout: 'Atsijungimas',
      rfidsignin: 'Prisijunkite naudodami RFID',
      SignInpassword: 'Prisijunkite kaip slaptažodį',
      ScanRFID: 'Nuskaitykite savo RFID žymą',
      dashboard: 'Prietaisų skydelis',
      timer: 'Laikmatis',
      projects: 'Projektai',
      stemp: 'Pažymėkite į',
      calendar: 'Kalendorius',
      deviation: 'Nukrypimas',
      home: 'Pradžia',
      deliver: 'Pristatymas',
      more: 'Daugiau',
      files: 'Dokumentai',
      equipments: 'Įranga',
      checklists: 'Patikrinimo sąrašai',
      drawing: 'Piešimas',
      pressureTestReport: 'Slėgio bandymo ataskaita',
      weldlog: 'Suvirinimo žurnalas',
      event: 'įvykis',
      ndt: 'NDT',
      surfaceReport: 'Paviršiaus ataskaita',
      technicalReport: 'Techninė ataskaita',
      matrialList: 'Medžiagų sąrašas',
      pwht: 'PWHT',
      pwps: 'PWPS',
      wps: 'WPS',
      warehouse: 'Sandėlis',
      tasks: 'Užduotys',
      orders: 'Užsakymai',
      facilities: 'Priemonė',
      chemicallist: 'Medžiagų sąrašas',
      asbuilt: 'Kaip pastatyta',
      autoLogout: 'automatinis atsijungimas'
    },
    login: {
      language: 'Kalba',
      back: 'Atgal',
      userName: 'Vartotojo vardas',
      password: 'Slaptažodis',
      authFailed: 'Autentiškumo nustatymas nepavyko !',
      networkError: 'Nepavyksta prisijungti prie serverio. Patikrinkite ryšį ir serverio adresą.',
      invalidCredentials: 'Neteisingas vartotojo vardas arba slaptažodis !',
      serverError: 'Serveris negalėjo užbaigti prisijungimo. Susisiekite su pagalbos tarnyba.',
      host: 'Šeimininkas',
      forgotPassword: 'Pamiršote slaptažodį ?',
      forgotPasswordHint: 'Įveskite savo el. pašto adresą, kad gautumėte slaptažodžio atstatymo nuorodą.',
      backToLogin: 'Grįžti prie prisijungimo',
      emailAddress: 'El. pašto adresas',
      resetMyPassword: 'Atstatyti slaptažodį'
    },
    common: {
      pwaNotEnabled: 'PWA neįjungtas, susisiekite su administratoriumi',
      delete_row: 'Ištrinti eilutę',
      install: 'Įdiekite šią programą savo pagrindiniame ekrane, kad galėtumėte greitai ir lengvai pasiekti, kai esate kelyje.',
      justTab: 'Tiesiog bakstelėkite',
      addToHome: 'tada "Įtraukti į pagrindinį ekraną".',
      english: 'Anglų kalba',
      norwegian: 'Norvegų kalba',
      lithuanian: 'Lietuvių kalba',
      polish: 'Lenkų kalba',
      swedish: 'Švedų kalba',
      save: 'Išsaugoti',
      saveAndClose: 'Išsaugoti ir uždaryti',
      send: 'Siųsti',
      edit: 'Redaguoti',
      cancel: 'Atšaukti',
      update: 'Atnaujinti',
      delete: 'Ištrinti',
      updateAndClose: 'Atnaujinti ir uždaryti',
      close: 'Uždaryti',
      new: 'Naujas',
      isActive: 'Yra aktyvus',
      addNew: 'Pridėti naują',
      savedSuccess: 'Sėkmingai išsaugota!',
      addedSucess: 'Sėkmingai pridėta !',
      updatedSuccess: 'Sėkmingai atnaujinta !',
      deleteSuccess: 'Sėkmingai pašalinta !',
      errorOccured: 'Įvyko klaida !',
      backToList: 'Grįžti į sąrašą',
      search: 'Paieška',
      yes: 'Taip',
      no: 'Ne',
      isDefault: 'Ar numatytoji',
      loadingMsg: 'Kraunasi, palaukite',
      deleteConfirm: 'Ištrinti Patvirtinti',
      areYouSure: 'Ar tikrai norite ištrinti ?',
      validationIssue: 'Patikrinkite privalomus laukus!',
      total: 'Iš viso',
      noResults: 'Rezultatų nerasta !',
      statusUpdateFailed: 'Būsena nebuvo išsaugota. Bandykite dar kartą.',
      increaseHeight: 'Padidinti aukštį',
      decreaseHeight: 'Sumažinti aukštį',
      others: 'Kiti',
      typeHere: 'Įveskite čia...',
      position: 'Pozicija',
      color: 'Spalva',
      maxCharacters: 'Maksimalus {charCount} simbolių skaičius',
      changedPassword: 'Slaptažodis sėkmingai pakeistas',
      import: 'Importuoti',
      note: 'Pastaba',
      invalidEmail: 'Neteisingas el. paštas',
      no_records: 'Įrašų nerasta!',
      no_data: 'Nėra duomenų',
      ok: 'Gerai',
      date: 'Data',
      comments: 'Komentarai',
      draftMsg: 'Išsaugota kaip projektas',
      createProjectRole: 'Sukurti projekto vaidmenį',
      updateProjectRole: 'Atnaujinti projekto vaidmenį',
      module: 'Modulis',
      selectTemplate: 'Pasirinkite šabloną',
      documentTemplate: 'Dokumento šablonas',
      download: 'Atsisiųsti',
      uploadedSuccess: 'Sėkmingai įkelta !',
      weekTotalHours: 'Savaitės val.',
      addWorktype: 'Pridėti darbo tipą',
      updateWorktype: 'Atnaujinti darbo tipą',
      worktype: 'Darbo tipas',
      newUpdate: 'Galimas naujas atnaujinimas!',
      refresh: 'Atnaujinti',
      retry: 'Bandyti dar kartą',
      somethingWentWrong: 'Įvyko klaida',
      online: 'Prisijungta',
      offline: 'Neprisijungęs',
      moduleName: 'Modulio pavadinimas',
      updatedOn: 'Atnaujinta',
      columns: 'Stulpeliai',
      confirmCancel: 'Patvirtinti Atšaukti',
      areYouSureCancel: 'Ar tikrai norite atšaukti ?',
      not_approved_notification: 'Sveiki! {count} laiko registracija (-os) per savaitę {weeknumber} nepatvirtinta',
      hourExceedNotification: 'Įvesta valanda viršija 24 valandas',
      options: 'Parinktys',
      label: 'Etiketė',
      value: 'Reikšmė',
      confirmStatusChange: 'Patvirtinti būsenos pasikeitimą',
      areYouSureToChangeStatus: 'Ar tikrai norite pakeisti būseną į {statusText} ?',
      complete: 'užbaigta',
      incomplete: 'neužbaigta',
      name: 'Pavadinimas',
      number: 'Skaičius',
      noPermission: 'Atsiprašome! Jūs neturite leidimo {permissionType} {module}',
      charsLimit35: 'Prašome įvesti ne daugiau kaip {length} simbolių',
      confirmAddHour: 'Pamaina baigta!',
      sureToAddExceedingHour: 'Įvesta valanda viršija darbo valandas, Ar tikrai norite pridėti ?',
      warning: 'Įspėjimas',
      required: 'Reikalinga',
      timerFeatureDisabled: 'Laikmačio funkcija išjungta',
      locationNotSet: 'Nenustatyta vieta',
      type: 'Tipas',
      changeVideoSource: 'Keisti vaizdo šaltinį',
      permissionDenied: 'Fotoaparato leidimas yra uždraustas!, įgalinkite jį naršyklės nustatymuose!',
      time: 'Laikas',
      orderno: 'Užsakymo Nr.',
      ready_for_production: 'Paruošta gamybai',
      production: 'Gamyba',
      on_hold: 'Sulaikyta',
      finished: 'Baigta',
      of: 'iš',
      ndt_percentage_error: 'NDT procentas turi būti nuo 0 iki 100',
      lengthError: 'Ilgis turi būti mažesnis nei 10',
      update_properties: 'Atnaujinti ypatybes',
      add_properties: 'Pridėti ypatybes',
      preparing_fields: 'Ruošiami laukai...',
      from_attributs: 'FORMOS ATtributai',
      enter_title: 'Įveskite kiekvieno stulpelio pavadinimą:',
      loading_grid: 'Įkeliami tinkleliai...',
      from_properties: 'MODULIO SAVYBĖS',
      dragging: 'Vilkite...',
      catch_up: 'Viskas paimta!!!',
      add_header: 'Pridėti antraštę',
      add_footer: 'Pridėti poraštę',
      drop_fields: 'Palikite laukus čia',
      for_header: 'PAGAL ANTRAŠTĘ',
      for_footer: 'PUSLAPIO PĖDAI',
      add_html: 'PRIDĖTI HTML TURINĮ',
      relate: 'Susiję',
      unrelate: 'Nesusijusios',
      values: 'Vertybės',
      scan: 'Nuskaityti',
      filename: 'Failo pavadinimas',
      fitToScreen: 'Pritaikyti prie ekrano',
      actualSize: 'Tikrasis dydis',
      zoomIn: 'Priartinti',
      zoomOut: 'Atitraukti',
      reset: 'Atkurti',
      doYouWantContinue: 'Ar vis dar norite tęsti?',
      stempHint: 'Jei pasirinksite Shift, galėsite pradėti štampuoti',
      hoursExeed: 'viršija 24 valandas',
      on: 'ĮJUNGTA',
      reachedHours: 'Pasiekė 24 val',
      invaliHours: 'Netinkamas laikas',
      notValidNumber: 'Neteisingas numeris',
      invalidName: 'Neteisingas pavadinimas',
      filterSaveResult: 'Paieška leidžia matyti pritaikytą filtrą, o išfiltruotą rezultatą galima matyti ataskaitoje tik išsaugojus kontrolinį sąrašą',
      seemsInvalid: 'Atrodo, kad laikas netinkamas!',
      shiftContinue: 'Jūsų plakimo valanda tęsiasi...',
      no_fields_found: 'Kontrolinio sąrašo laukų nerasta',
      sharePoint: '„Sharepoint“ gali turėti neteisingus kredencialus arba trūkti konfigūracijų!.',
      specifyTheNumberOfColumnsToBeIncludedInTheGridComponent: 'Nurodykite stulpelių, kurie turi būti įtraukti į tinklelio komponentą, skaičių',
      dragAndDropTips: 'Išsaugoti privaloma kiekvieną kartą nuvilkant ir numetant, kad būtų išvengta klaidingų eilučių',
      afterCopyFilter: 'Filtro veiksmas bus atliekamas tol, kol išsaugosite kontrolinį sąrašą',
      archived: 'Archyvuota',
      datagrid_filter_help_text_1: 'Rezultatai bus filtruojami taip pat, kaip ir paskutinį kartą filtravimo parinktys.',
      datagrid_filter_help_text_2: 'Pridėjus naują eilutę, filtrai bus pašalinti ir visos eilutės bus pridėtos.',
      datagrid_filter_help_text_3: 'Filtrai neskiria didžiųjų ir mažųjų raidžių, todėl galime naudoti ir didžiąsias, ir mažąsias.',
      datagrid_filter_help_text_4: 'Negalime du kartus filtruoti to paties stulpelio.',
      datagrid_filter_help_text_5: 'Jei vartotojas išsaugos kontrolinį sąrašą, vilkimas bus pakeistas pagal filtro rezultatą.',
      datagrid_filter_help_text_6: 'Teksto sritis, filtruojama pagal žodį tarp bet kurios sakinio dalies.',
      datagrid_filter_help_text_7: 'Privaloma užpildyti abu laukus, o reikšmė – atlikti filtro veiksmą.',
      sharepointCharacters: 'Šiame lauke neturėtų būti šių simbolių „*:<>?/\\|.“',
      company: 'Bendrovė',
      filenotfound: 'Failas nerastas',
      folder: 'Aplankas',
      folders: 'Aplankai',
      files: 'Failai',
      emptyFolder: 'Šis aplankas tuščias',
      emptyFolderHint: 'Čia bus rodomi paskelbti dokumentai',
      gridView: 'Tinklelio rodinys',
      listView: 'Sąrašo rodinys',
      back: 'Atgal',
      searchResults: 'Paieškos rezultatai',
      previousDocument: 'Ankstesnis dokumentas',
      nextDocument: 'Kitas dokumentas',
      imagedraw: 'Vaizdo piešimas'
    },
    timer: {
      stop: 'Sustabdyti',
      ga_til_time: 'Eiti į valandų sąrašą',
      minutes: 'minučių',
      start: 'Pradėti',
      place: 'Vieta',
      hours: 'Valandos',
      activity: 'Veikla',
      inactive_suffix: '(neaktyvus)',
      not_linked_warning: 'Šis įrašas nebus perkeltas į {integration} — kažkas nesusieta',
      pause: 'Pauzė',
      from: 'Iš',
      till: 'Iki',
      shift: 'Pamainų sąrašas',
      startTime: 'Pradžios laikas',
      endTime: 'Pabaigos laikas',
      editHours: 'Redaguoti valandą',
      approved: 'Patvirtinta',
      notApproved: 'Nepatvirtinta',
      delivered: 'Pristatytas',
      notDelivered: 'Nepristatytas',
      year: 'Metai',
      week: 'Savaitė',
      nonBillable: 'Atostogos / nebuvimas',
      hourlogging: 'Valandų registravimas',
      noHours: 'Nerasta valandų pristatymui !',
      deliveredMsg: 'Sėkmingai pristatyta',
      addHours: 'Pridėti valandą',
      deliverHours: 'Pristatymo valandos',
      hoursExceeding: 'Laikmatis viršijo 8 val.',
      cancelTimer: 'Atšaukti laikmatį',
      uploadSuccess: 'Sėkmingas įkėlimas',
      picture: 'Nufotografuoti',
      imageNeeded: 'Prieš sustabdydami laikmatį įkelkite nuotrauką!',
      nonbillableworktype: 'Atostogų / nebuvimo tipas',
      additionalWorktype: 'Papildomas darbo tipas',
      additional_hours: 'Papildomos valandos',
      overtimeToFlex: 'Siųsti viršvalandžius į lankstųjį kontą',
      switchProject: 'Perjungti projektą',
      reasonForSwitchingProject: 'Priežastis, dėl kurios perjungiate projektą',
      projectSwitchedSuccessfully: 'Projektas sėkmingai perjungtas',
      failedToSwitchProject: 'Nepavyko perjungti projekto',
      selectDifferentProject: 'Pasirinkite kitą projektą'
    },
    projects: {
      chatOpen: 'Atidaryti',
      chatEditMembers: 'Redaguoti dalyvius',
      chatEditMembersHint: 'Pažymėkite, kas turi dalyvauti pokalbyje. Pridėtas asmuo matys visą istoriją.',
      chatCreate: 'Kurti',
      chatParticipants: 'Dalyviai',
      chatNewPrivate: '+ Naujas',
      chatSend: 'Siųsti',
      chatPrivate: 'Privatus',
      chatSeenBy: 'Matė {count}',
      chatSent: 'Išsiųsta',
      chatEveryone: '{count} dalyvių · visi turintys prieigą prie projekto',
      chatPrivateOnly: 'Tik {names} gali matyti šį pokalbį',
      chatNewPrivateTitle: 'Naujas privatus pokalbis',
      chatNewPrivateHint: 'Pasirinkite, kas gali matyti šį pokalbį.',
      chat: 'Pokalbiai',
      chatConversations: 'Pokalbiai',
      chatEmpty: 'Žinučių dar nėra.',
      chatPlaceholder: 'Rašykite žinutę...',
      chatOpenWeldMapping: 'Open weld mapping',
      chatYou: 'jūs',
      chatEdited: 'redaguota',
      chatConfirmDelete: 'Ištrinti šią žinutę?',
      chatToday: 'Šiandien',
      chatYesterday: 'Vakar',
      startDate: 'Pradžios data',
      endDate: 'Pabaigos data',
      projectNo: 'Projekto nr.',
      projectname: 'Projekto pavadinimas',
      aoRanked: 'AO Ranked',
      workOrderName: 'Darbo užsakymo pavadinimas',
      all: 'Visi',
      allActive: 'Visi Aktyvūs',
      myAll: 'Mano visi',
      myActive: 'Mano Aktyvus',
      project: 'Projektas',
      customer: 'Klientas',
      status: 'Būklė',
      noActiveProjects: 'Nėra aktyvių projektų!',
      selectProject: 'Pasirinkite projektą',
      projectMaterialDisabled: 'Medžiagos, kurios šiam projektui yra išjungtos',
      drawingGroup: 'Piešimo grupė',
      sectionIdentification: 'Identifikacija',
      sectionStatusAttachments: 'Būsena ir priedai',
      sectionReportDetails: 'Ataskaitos duomenys'
    },
    calendar: {
      today: 'Šiandien',
      month: 'Mėnuo',
      day: 'Diena',
      weekNotExists: 'Savaitė neegzistuoja',
      yearValid: 'Turi būti keturi skaitmenys',
      valid: 'Turi būti galiojantis',
      yearTooLessValidation: 'Metai turi būti didesni nei 1920 m.',
      weekLock: 'Pasirinktos datos yra užrakintoje savaitėje',
      dayLocked: 'Pasirinkta data yra užrakintoje savaitėje',
      otherHourEntries: 'Kiti valandų įrašai'
    },
    shifts: {
      shift: 'Mano pamainos',
      documents: 'Dokumentai:',
      not_found: 'Aprašymo ir url nerastas.',
      notValidPausedTime: 'Pauzės laikas yra ilgesnis nei pamainos laikas',
      continue: 'Tęsk',
      clear: 'Aišku',
      shiftEndsAt: 'Pamaina baigiasi'
    },
    deviation: {
      deviations: 'Nuokrypis',
      register_deviation: 'Registruoti nukrypimą',
      view_deviation: 'Peržiūrėti nukrypimą',
      high: 'Didelis',
      medium: 'Vidutinis',
      low: 'Mažas',
      closed: 'Uždaryta',
      registered: 'Registruota',
      process: 'Procesas',
      actions: 'Veiksmai',
      title: 'Pavadinimas',
      reported_by: 'Pranešė',
      location: 'Vieta',
      reason: 'Priežastis',
      document: 'Dokumentas',
      category: 'Kategorija',
      estimate_cost: 'Sąmata Išlaidos',
      severity: 'Sunkumas',
      deviation_status: 'Nukrypimas Būklė',
      deadline: 'Terminas',
      description: 'Aprašymas',
      responsible: 'Atsakingas',
      copyto: 'Kopija Į',
      upload_files: 'Įkelti',
      required_message: 'Šis laukas yra privalomas',
      consequences: 'Pasekmės',
      changeRequest: 'Modifikuoti prašymą',
      hse: 'DSS',
      deviation_number: 'Nukrypimo numeris',
      underlying_reason: 'Pagrindinė priežastis',
      corrective_actions: 'Taisomieji veiksmai',
      effect_of_measures: 'Priemonių poveikis',
      sectionRegistration: 'Registracija',
      sectionClassification: 'Klasifikacija',
      sectionFollowUp: 'Tolesni veiksmai',
      sectionWhatHappened: 'Kas įvyko',
      sectionCorrectiveAction: 'Korekciniai veiksmai',
      sectionAttachments: 'Priedai',
      readonlyNotice: 'Neturite teisės redaguoti šio neatitikimo. Laukai rodomi tik informaciniais tikslais.'
    },
    checklist: {
      title: 'Kontrolinis sąrašas',
      updateChecklist: 'Atnaujinti kontrolinį sąrašą',
      pickCheckList: 'Pasirinkite kontrolinį sąrašą',
      addCheckList: 'Pridėti kontrolinį sąrašą',
      hmsKs: 'HMS/KS',
      templateName: 'Šablono pavadinimas',
      checklist_recipients: 'El. pašto gavėjas',
      checklist_recipient_hint: 'Įveskite el. paštą atskirdami kableliu (,).',
      projectnr: 'PO Nr.',
      projectname: 'Projekto pavadinimas',
      aonr: 'AO Nr.',
      workordername: 'Darbo užsakymo pavadinimas',
      customer: 'Klientas',
      customercontact: 'Kliento kontaktas',
      projectleader: 'Projekto vadovas',
      report_header: 'Ataskaitos antraštė',
      importCSV: 'Importuoti CSV',
      CSVFileInfo: 'Čia galite importuoti duomenis iš csv failo į kontrolinį sąrašą.',
      removeRow: 'Pašalinkite 1-ą eilutę, jei joje yra antraštės.',
      sameOrederColumn: 'Įsitikinkite, kad stulpeliai yra tokia pat tvarka, kaip apibrėžėte kontroliniame sąraše.',
      semicolonDelimiter: 'Naudokite kabliataškį kaip csv skirtuką.',
      withoutImport: 'Be importo',
      addCSVFile: 'Pridėti CSV failą',
      copy_confirm: 'Ar norite kopijuoti kontrolinį sąrašą?',
      filter: 'Filtras',
      apply: 'Taikyti',
      image: 'Vaizdas',
      no_comment: 'Nėra komentarų',
      action: 'Veiksmas',
      cameraCapture: 'Fotoaparato užfiksavimas',
      openCamera: 'Atidaryti kamerą',
      takePhoto: 'Užfiksuoti nuotrauką',
      uploadDocument: 'Atidaryti kamerą ir įkelti nuotrauką',
      retake: 'Perimti'
    },
    equipments: {
      equipment: 'Įranga',
      addEquipment: 'Pridėti įrangą',
      updateEquipment: 'Atnaujinti įrangą',
      viewEquipment: 'Peržiūrėti įrangą',
      active: 'Aktyvus',
      quarantine: 'Karantinas',
      discarded: 'Išmestas',
      warrantydate: 'Garantijos data',
      dateofPurchase: 'Pirkimo data',
      vendor: 'Pardavėjas',
      modelNumber: 'Modelio numeris',
      product: 'Produktas',
      serialNumber: 'Serijinis numeris',
      capacity: 'Talpa',
      groups: 'Grupės',
      plannedCalibration: 'Planuojamas kalibravimas',
      scrapDate: 'Lūžio data',
      equipmentNumber: 'Įrangos numeris',
      placement: 'Vieta',
      notifyByEmail: 'Pranešti el. paštu',
      mustAllocateToProjectOrLocation: 'Turi priskirti įrangą projektui arba vietai.',
      confirm: 'Ar tu tuo tikras?'
    },
    customModule: {
      modules: 'Moduliai',
      customModule: 'Pasirinktinis modulis',
      customModules: 'Pasirinktiniai moduliai',
      uploadDocument: 'Įkelti dokumentą',
      isCompleted: 'Yra užbaigtas',
      add: 'Pridėti',
      urlNotFound: 'Atsisiųsti url nerastas',
      completed: 'Užbaigta',
      notCompleted: 'Neužbaigta',
      fileSizeLimitMsg: 'Viršyta vieno ar daugiau failų dydžio riba (Max.Limit {maxSize}MB).',
      invalidFileType: 'Failo tipas neleidžiamas'
    },
    moduleReports: {
      title: 'Modulių ataskaitos',
      chartyAxis: 'Įrašų skaičius (vienam moduliui)'
    },
    projectFeature: {
      drawingNumber: 'Brėžinio Nr.',
      poRanked: 'PO Užimama vieta',
      operator: 'Operatorius',
      reportNumber: 'Ataskaitos Nr.',
      uploadNdtDocument: 'Įkelti NDT dokumentą',
      aoRanked: 'AO reitingas',
      NDTSpecifications: 'NDT specifikacijos',
      NDTScope: 'NDT taikymo sritis',
      filterMaterials: 'Filtravimo medžiagos',
      chargedLotNumber: 'Charde/Lot nr.',
      selectFiles: 'Pasirinkti failus',
      createdOn: 'Sukurta nuo',
      weldingID: 'Suvirinimo ID',
      weldNumber: 'Suvirinimo Nr.',
      wpsNumber: 'WPS nr.',
      wpsAsComma: 'Įveskite WPS Nr. Kaip kableliais atskirtą.',
      weldEnd: 'Suvirinimo pabaiga',
      vtSignDate: 'VT ženklas./ data',
      rtSignDate: 'RT Sign./Data',
      utSignDate: 'UT Sign./Data',
      mtPtSignDate: 'MT/PT Sign./Data',
      createdDate: 'Sukūrimo data',
      tegNr: 'Teg nr.',
      tegNrWpsNr: 'Teg nr. / Wps nr.',
      posNr: 'Pozicijos Nr.',
      batchNr: 'Partijos Nr.',
      heatNr: 'Šilumos Nr.',
      onStock: 'Sandėlyje',
      weldingConsumable: 'Suvirinimo medžiaga',
      registerBatchAgainstWps: 'Registruoti partijos nr. pagal WPS, suvirinimo žurnalui',
      out: 'Išparduota',
      sectionIdentification: 'Identifikacija',
      sectionStock: 'Atsargos',
      sectionStatus: 'Būsena ir priedai',
      descriptionHint: 'Aprašymas',
      recordNumber: 'Įrašo numeris',
      chartSpeed: 'Diagrama Greitis',
      chartNumber: 'Diagramos numeris',
      unrestrictedTo: 'Neribota iki',
      restrictedRateOfRise: 'Apribotas Kilimo greitis',
      holdTemperatureRequired: 'Reikiama laikymo temperatūra',
      holdTemperatureActual: 'Faktinė sulaikymo temperatūra',
      holdTimeActual: 'Laikymo laikas Faktinis',
      holdTimeRequired: 'Reikalaujama išlaikymo trukmė',
      restrictedRateDown: 'Apribotas mažėjimo greitis',
      unrestrictedRateOfFall: 'Neribotas kritimo greitis',
      weldDate: 'Suvirinimo data',
      performedBy: 'Atliko',
      approvedBy: 'Patvirtino',
      approvedDate: 'Patvirtinta data',
      weldLogDate: 'Suvirinimo data',
      productNumber: 'Produkto numeris',
      weldLength: 'Suvirinimo ilgis (mm)',
      designation_1: 'Dalis 1 Žymėjimas',
      designation_2: 'Dalis 2 Žymėjimas',
      thickness_1: 'Storis 1 (mm)',
      thickness_2: 'Storis 2 (mm)',
      weld_diameter: 'Suvirinimo skersmuo (mm)',
      notAccepted: 'Nepriimta',
      ndtStatus: 'NDT būsena',
      isDiameter: 'Ar skersmuo',
      ndt: '%NDT',
      weldingCompound: 'Suvirinimo mišinys',
      batch_lot: 'Batc/lot',
      choose: 'Pasirinkite',
      pipe_description: 'Vamzdžio aprašymas'
    },
    whsDashboard: {
      scanText: 'Nuskaityti užsakymo numerį arba brūkšninį kodą',
      customerOrder: 'Kliento užsakymai',
      receiveSupplierOrder: 'Gauti tiekėjo užsakymus',
      adjustmentOrders: 'Koregavimo užsakymai',
      transferOrders: 'Perdavimo užsakymai',
      cycleCount: 'Ciklo skaičiavimas',
      product: 'Produktas',
      supplierOrder: 'Tiekėjo užsakymas',
      returnOrder: 'Grąžinimo užsakymas'
    },
    ccsheet: {
      warehouse: 'Sandėlis',
      created: 'Sukurta',
      counted: 'Suskaičiuota',
      count: 'Skaičius',
      reCount: 'Perskaičiavimas',
      closeComplete: 'Uždaryti ir užbaigti',
      unit: 'Vienetas',
      stock: 'Atsargos',
      scanLocation: 'Nuskaitykite arba įveskite vietą',
      nextLoc: 'Kita vieta',
      info: 'Žinutė!',
      continueCount: 'Tęsti skaičiavimą',
      clearAndRecount: 'Išvalyti ir perskaičiuoti',
      completeRecount: 'Užbaigti perskaičiavimą',
      ccsheetComplete: 'CCSheet bus užpildytas. Tęsti?',
      noSheetFound: 'CCSheet nerastas!',
      noProductOnLocation: 'Šioje vietoje nerastas joks produktas!',
      stockTake: 'Pasirinktos vietos inventorizacija jau atlikta. Ar norite tęsti skaičiavimą šioje vietoje, ar išvalyti duomenis ir atlikti naują inventorizaciją?',
      ccsheetAddProduct: 'Produktas nepridėtas į šią ccsheet norėtumėte pridėti ?'
    },
    product: {
      supplierartno: 'Tiekėjo prekės numeris',
      supplier: 'Tiekėjo pavadinimas',
      barcode: 'Brūkšninis kodas',
      noProductFound: 'Produkto nerasta!',
      minQty: 'Mažiausias kiekis',
      orderQty: 'Užsakymo kiekis',
      qty: 'Kiekis',
      batch: 'Partija',
      scanLoc: 'Pasirinkite vietą',
      noLocFound: 'Vietos nerasta!'
    },
    order: {
      products: 'Produktai',
      avail: 'Turima',
      ordered: 'Ord.',
      received: 'Rec.',
      pickedQty: 'Nuotr.',
      pickOrder: 'Parinkti užsakymą',
      delivery: 'Del',
      pickProducts: 'Rinkti produktus',
      rest: 'Poilsis',
      complete: 'Pilnas',
      pick: 'Išsirinkti',
      scanProduct: 'Nuskaitykite gaminio brūkšninį kodą',
      scanBatch: 'Nuskaitykite partijos numerį',
      picked: 'Surinkta',
      toPick: 'Parinkti',
      location: 'Vieta',
      pickLocation: 'Pasirinkite vietą',
      qtyExceeds: 'Kiekis viršija',
      noOrderFound: 'Užsakymo nerasta!',
      notValidBatch: 'Partijos numeris negalioja!',
      receiveOrder: 'Gauti užsakymą',
      receive: 'Gauti',
      batchExists: 'Partijos numeris jau egzistuoja!',
      receiveWarning: 'Ar norėtumėte papildyti {product} atsargas {qty} vnt.',
      completedSuccess: 'Sėkmingai įvykdyta!',
      addFreight: 'Ar norite pridėti krovinį?',
      cost: 'Išlaidos',
      price: 'Kaina',
      orderedQtyHigh: 'Gautas kiekis yra didesnis nei užsakytas, ar norite tęsti?',
      collect: 'Surinkti',
      receiving: 'Gavimas',
      availableToPick: 'Gautinas (-i) kiekis (-ai), kurį (-iuos) reikia gauti',
      adjust: 'Koreguoti',
      orderComplete: 'Užsakymas bus įvykdytas. Tęsti?',
      orderDate: 'Užsakymo data'
    },
    tasks: {
      forYour: 'Jūsų',
      information: 'informacijai',
      acknowledge: 'Patvirtinkite',
      review: 'Peržiūrėkite',
      approval: 'Patvirtinimas',
      subject: 'Tema',
      dueDate: 'Terminas',
      approve: 'Patvirtinti',
      disapprove: 'Nepritarti',
      keep: 'Palikti',
      remove: 'Pašalinti'
    },
    mixed: {
      scanSerialNumber: 'Nuskaityti serijos numerį',
      noEquipmentFound: 'Įrangos nerasta',
      sharedUrl: 'Bendrinamas URL',
      checklistfiles: 'Kontrolinių bylų failai',
      attachments: 'Priedai',
      signature: 'Parašas',
      nochecklists: 'Nėra kontrolinių sąrašų',
      checklistName: 'Kontrolinio sąrašo pavadinimas',
      noOfDocuments: 'Dokumentų skaičius',
      documentTitle: 'Dokumento pavadinimas',
      qrCode: 'QR kodas',
      qrQty: 'QR kiekis',
      scanQRCode: 'Skanuokite QR kodą',
      irscanner: 'IR skeneris',
      attachmentsBelow: 'Raskite toliau pateiktus priedus',
      noChemicalFound: 'Cheminių medžiagų sąrašo nerasta',
      barCodeNotDecoded: 'Nepavyko iššifruoti brūkšninio kodo iš QR kodo.',
      scanBarcode: 'Nuskaityti brūkšninį kodą'
    },
    chemicallist: {
      chemical: 'Cheminis',
      provider: 'Teikėjas',
      repository: 'Saugykla',
      last_revised: 'Paskutinį kartą peržiūrėta',
      viewChemical: 'Cheminis',
      chemicalName: 'Cheminis pavadinimas'
    },
    news: {
      news: 'Naujienos',
      next: 'Kitas',
      previous: 'Ankstesnis'
    },
    // Production series (WIT-PROTO-PRODSERIES-PWA-001). Copy mirrors the
    // backend's resources/lang/lt/production_series.php (key in comment).
    productionSeries: {
      idModeSpool: 'Spool/part no.', // id_mode_spool
      idModeSeq: 'Without spool/part no. — sequence number', // id_mode_seq
      seriesOf: 'Series', // series_of
      nWelds: '{n} welds', // n_welds
      hasProductionData: 'Has production data', // has_production_data
      unitsWelds: '{units} units · {welds} welds', // units_welds
      unitRetainedSuffix: ' · retained', // unit_retained_suffix
      markerDone: '{done}/{total} welded', // marker_done
      noUnit: 'no spool/part no.' // Decision B tag (task copy)
    },
    weldMapping: {
      // 5183 / S18: one batch/heat per welding method.
      methodBatchesLabel: 'Partija / lydinys pagal metodą',
      methodBatchesHint: 'Šiai siūlei naudojamas daugiau nei vienas suvirinimo metodas. Užregistruokite kiekvienam naudotą partiją.',
      // 5183 / S4: production-series units under a drawing.
      unitsHeading: 'Ritinio / dalies numeriai',
      unitScoped: 'Rodoma ritinys {unit}',
      unitShowAll: 'Rodyti visus',
      unsavedHint: 'Neišsaugoti pakeitimai — spauskite mygtuką žemiau, kad juos atmestumėte',
      batchMissing: 'Partija nenurodyta — įveskite prieš užbaigdami',
      supersededBy: 'Pakeista {weld} — registruokite remontą toje siūlėje',
      previewWps: 'Peržiūrėti WPS',
      comment: 'Komentaras',
      copyMaterial: 'Kopijuoti medžiagą',
      vtRejectedOn: 'VT atmesta',
      by: '—',
      reason: 'Priežastis:',
      repairOf: 'Remontas',
      wireBatchTitle: 'Suvirinimo viela · partija',
      batchPf: 'Suvirinimo pridėtinės medžiagos partija',
      batchPfHint: 'Nuskaitykite arba įveskite partiją…',
      assemblyPf: 'Surinkimo (PF) sertifikatas (nebūtina)',
      weldCertificate: 'Suvirintojo sertifikatas',
      certGroupQualified: 'Kvalifikuota',
      certGroupCannotVerify: 'Negalima patikrinti',
      certGroupNotQualified: 'Nekvalifikuota',
      certNoneQualified: 'Nėra šiai siūlei tinkamų sertifikatų',
      certLockedTitle: 'Siūlė užrakinta — trūksta sertifikato',
      certLockedMsg: 'Neturite sertifikato, tinkamo šiai siūlei. Kreipkitės į suvirinimo koordinatorių.',
      certAdvisoryTitle: 'Sertifikatas nepatvirtintas',
      certAdvisoryMsg: 'Nė vieno jūsų sertifikato nepavyko patvirtinti šiai siūlei. Galite pasirašyti — sprendimas bus užfiksuotas prie siūlės.',
      // WIT-FIX-CERT-5348-001 F5a: the advisory is a not_qualified finding, not cannot_verify.
      certNotQualifiedTitle: 'Neapima sertifikatas',
      // WIT-FIX-CERT-5355-001 F5a / D-5355-3 (Erik 15.10): what none of the welder's certificates covers, then how to go on.
      certNotQualifiedMsg: 'Nė vienas jūsų sertifikatas neapima šios siūlės{codes}. Galite pasirašyti nurodę priežastį — ją matys suvirinimo koordinatorius.',
      certNotQualifiedLead: 'Nė vienas jūsų sertifikatas neapima šios siūlės.',
      certSignWithReasonHint: 'Galite pasirašyti nurodę priežastį — ją matys suvirinimo koordinatorius.',
      certReasonWelder: 'Trumpai nurodykite, kodėl pasirašote be kvalifikuojančio sertifikato (pvz., „sertifikatas dar neužregistruotas“). Suvirinimo koordinatorius matys priežastį suvirinimo žurnale.',
      certNoValidMsg: 'Neturite galiojančio suvirintojo sertifikato šiai siūlei. Galite pasirašyti — siūlė bus pažymėta suvirinimo koordinatoriui.',
      certMissingProcess: ' (trūksta metodo {codes})',
      // F2: the office override on the sheet (server weld_mapping.cert_ui.override_tip_* twins).
      certOverrideTipReason: 'Priežastis: {reason}',
      certOverrideTipBy: 'Kas: {by}',
      certOverrideTipAt: 'Kada: {at}',
      certAutoHint: 'Parenkamas automatiškai iš jūsų galiojančių sertifikatų paspaudus «Suvirinta».',
      certConfirmTitle: 'Patvirtinkite sertifikatą',
      certConfirmBtn: 'Patvirtinti',
      // WIT-FIX-RETEST-1008-001 P-C: under the confirm intro, only for «Kan ikke verifiseres».
      certConfirmManualNote: 'Your choice is marked «Confirmed manually» and shown to the welding coordinator.',
      // P-C: the chip for a welder's own confirmation (cert_verdict cannot_verify_confirmed).
      certVerdictConfirmed: 'Patvirtinta rankiniu būdu',
      // P-D: the stop under «Blokker» when nothing the welder holds can apply.
      certBlockedTitle: 'The weld cannot be registered',
      certOverrideTitle: 'Neapima sertifikatas',
      certOverrideBlock: 'Projektas reikalauja tinkamo sertifikato. Nurodykite priežastį, kad vis tiek pasirašytumėte — suvirinimo koordinatorius ją matys suvirinimo žurnale.',
      certOverrideWarn: 'Siūlė bus pasirašyta ir pažymėta suvirinimo koordinatoriui. Galite pridėti priežastį.',
      certReasonLabel: 'Priežastis',
      certReasonRequired: 'Būtina nurodyti priežastį.',
      // WIT-FIX-WELDMAP-002 (3.4 / 3.5) — needs native review
      certRankedTitle: 'Jūsų sertifikatai šiai siūlei:',
      welderIdMissing: 'Trūksta suvirintojo ID',
      welderIdMissingHint: 'Pasirašyta be suvirintojo ID — įrašykite suvirintojo ID savo naudotojo profilyje.',
      certSignBtn: 'Pasirašyti',
      certLockedOverride: 'Galite pasirašyti nurodę priežastį — suvirinimo koordinatorius ją matys.',
      certVerdictQualified: 'Kvalifikuotas',
      certVerdictUnverified: 'Nepatikrinta',
      certVerdictNotQualified: 'Nekvalifikuotas',
      certVerdictNotChecked: 'Nepatikrinta',
      // WIT-IMPL-CERT-001 P2/P3
      certVerdictOverride: 'Perrašytas',
      certFlaggedToast: 'Pasirašyta ir pažymėta suvirinimo koordinatoriui.',
      undoSign: 'Atšaukti pasirašymą',
      undoSignDone: 'Siūlės {weld} pasirašymas atšauktas.',
      // WIT-IMPL-CERT-001 P4 (office picker)
      certShowAllWelders: 'Rodyti visus įmonės suvirintojus',
      certNonParticipant: 'nedalyvauja projekte',
      certNonParticipantReason: 'Suvirintojas nedalyvauja projekte. Nurodykite priežastį — pasirinkimas bus išsaugotas kaip perrašymas.',
      noServerAnswer: 'Serveris neatsakė. Patikrinkite ryšį ir bandykite dar kartą — niekas nebuvo išsaugota.',
      certMatchChecking: 'Tikrinami sertifikatai…',
      // WIT-FIX-PWA-WELDERCERT-001 (Erik 09.10.2026): the welder's own picker.
      certAutoPick: 'Parenkama automatiškai · {n} tinkami',
      certOwnHeading: 'Jūsų tinkami sertifikatai',
      certOwnHidden: 'Paslėpta: {n} jūsų sertifikatų neapima proceso / siūlės tipo.',
      certNoCertificates: 'Neturite registruoto suvirintojo sertifikato. Kreipkitės į suvirinimo koordinatorių.',
      certNoneRelevant: 'Neturite sertifikato, tinkamo siūlei {weld}. Kreipkitės į suvirinimo koordinatorių.',
      assemblyPfHint: 'Pasirinkite sertifikatą …',
      search: 'Ieškoti',
      nSelected: 'pasirinkta {n}',
      assemblyPfNone: 'Nėra sertifikatų',
      batchPfRequired: 'Įveskite pridėtinės medžiagos partiją, kad užbaigtumėte surinkimą',
      required: 'privaloma',
      rejectWhy: 'Kodėl siūlė atmesta?',
      rejectNote: 'Pastaba (nebūtina)',
      vtLevelIso: 'VT lygis (ISO 5817)',
      vtLevelFromWeld: 'Nustatyta ant siūlės',
      vtLevelOverriding: 'Keičiamas lygis',
      vtLevelNotSet: 'Nenustatyta',
      vtLevels: {
        B: 'Griežtas',
        C: 'Vidutinis',
        D: 'Saikingas'
      },
      faults: {
        undercut: 'Pakirtimas',
        porosity: 'Poringumas',
        spatter: 'Tiškalai',
        fusion: 'Nesulydymas',
        geometry: 'Geometrija',
        other: 'Kita'
      },
      uploading: 'Įkeliama…',
      photoSaved: 'Nuotrauka įrašyta',
      fromWps: 'iš WPS',
      change: 'Keisti',
      batchCharge: 'Partija / lydinio nr.',
      batchChargeHint: 'Pasirinkite partiją …',
      batchAdd: 'Pridėti',
      batchAddNew: '+ Pridėti naują partiją …',
      batchGroupWps: 'Šiai WPS',
      batchTypeNew: 'Kita… (įveskite naują partiją)',
      batchPickFromList: 'Pasirinkti iš sąrašo',
      takePhoto: 'Fotografuoti',
      uploadPhoto: 'Įkelti nuotrauką',
      signedAs: 'Pasirašyta jūsų paskyra',
      title: 'Suvirinimo žemėlapis',
      featureDisabled: 'Neturite prieigos prie Suvirinimo žemėlapio.',
      searchDrawing: 'Ieškoti brėžinio',
      continue: 'Tęsti',
      lastOpened: 'Paskutinį kartą atidaryta',
      allDrawings: 'Visi brėžiniai',
      childDrawings: 'Antriniai brėžiniai',
      welds: 'siūlės',
      hasChildren: '{count} antriniai brėžiniai',
      noMatch: 'Nėra atitinkančių brėžinių',
      noMatchHint: 'Pabandykite kitą brėžinio numerį.',
      mapComingNext: 'Suvirinimo žemėlapis atsidarys čia kitame etape.',
      drawingsShort: 'Brėžiniai',
      prevDrawing: 'Ankstesnis brėžinys: {number}',
      nextDrawing: 'Kitas brėžinys: {number}',
      firstDrawing: 'Pirmas brėžinys',
      lastDrawing: 'Paskutinis brėžinys',
      ownJoints: 'Savos siūlės',
      ownMap: 'Atidaryti suvirinimo žemėlapį {number}',
      ownSub: '{count} siūlės pačiame brėžinyje',
      joints: 'Siūlės',
      toggleJoints: 'Rodyti arba slėpti siūlių sąrašą',
      noJoints: 'Šiame brėžinyje siūlių nėra',
      // Which STAGE a drawing has reached (D-5170-1).
      drawingStage: {
        pending: 'Not started',
        mapping: 'Being mapped',
        mapped: 'Mapped',
        welding: 'Being welded',
        ndt: 'Awaiting inspection',
        // «VT fullført» (WIT-IMPL-PWA-DRAWINGSTATUS-003): alt sveist og VT
        // signert, men en annen påkrevd NDT-metode gjenstår.
        vt_done: 'VT baigta',
        done: 'Complete'
      },
      status: {
        MAPPED: 'Pažymėta',
        FITTED: 'Sujungta',
        WELDED: 'Suvirinta',
        COMPLETED: 'Užbaigta',
        REPAIR: 'Remontas'
      },
      wps: 'WPS',
      process: 'Metodas',
      filler: 'Pridėtinė',
      vtLevel: 'VT lygis',
      trace: 'Atsekamumas',
      fittedBy: 'Sujungė',
      weldedBy: 'Suvirino',
      vtBy: 'VT atliko',
      batch: 'partija',
      wire: 'viela',
      level: 'lygis',
      vtRejectedBy: 'VT atmetė',
      vtPending: 'Laukiama VT kontrolės',
      field: {
        title: 'Field-registered weld',
        legend: 'Field-registered (awaiting office)',
        addBtn: 'Add weld in field',
        placeHint: 'Tap the drawing where the new weld goes',
        cancel: 'Cancel',
        queued: '{n} registration(s) waiting for connection',
        syncNow: 'Sync now',
        wpsDeviation: 'WPS deviation',
        newTitle: 'New weld – field-registered',
        editTitle: 'Edit field-registered weld',
        newSub: 'Registered by the welder on site and flagged for review by the office.',
        loadingOptions: 'Loading registers…',
        after: 'After weld',
        weldNr: 'Weld no.',
        idHint: 'Letter + the preceding weld\'s number: the first between W-0005 and W-0006 becomes A-0005, then B-0005, C-0005 …',
        reason: 'Reason',
        pickReason: 'Choose reason…',
        pick: 'Choose…',
        joint: 'Joint',
        groove: 'Groove type',
        pickGroove: 'Choose groove type…',
        pickJointFirst: 'Choose joint first',
        pickWps: 'Choose WPS…',
        material: 'Base material',
        materialsFailed: 'The material register could not be loaded. Try again, or tell the office.',
        thickness: 'Thickness (mm)',
        weldLength: 'Length mm',
        spool: 'Spool/part no.',
        pickSpool: 'Select spool/part no.…',
        spoolHint: 'This drawing has several spool/part numbers — pick the one this weld is on.',
        validRange: 'valid {min}–{max} mm',
        warnNotBlocking: 'The weld can be saved, but the deviation is flagged to the office.',
        warnMaterial: 'Material {material} is not covered by {wps}.',
        warnThickness: 'Thickness {t} mm is outside the WPS validity range ({min}–{max} mm).',
        // WIT-IMPL-WPS-5324-003 (F4): weld_mapping.field_wps_no_process twin.
        warnNoProcess: 'WPS {wps} nenurodytas suvirinimo procesas – sertifikato patikrinti negalima.',
        optional: 'optional',
        notePh: 'E.g. location, deviation, reference…',
        save: 'Save weld',
        registeredToast: '{weld} registered — sent to the office for review',
        queuedToast: '{weld} saved on the device — sent to the office when back online',
        updated: '{weld} updated',
        registered: 'Registered',
        reviewComment: 'Comment from the office',
        office: 'Office',
        approve: 'Approve',
        reject: 'Reject',
        remove: 'Remove from drawing',
        edit: 'Edit registration',
        rejectedNote: 'Rejected by the office — remove it or register the weld again.',
        localPending: 'Waiting for connection — not yet sent to the office.',
        delete: 'Delete registration',
        deleteConfirm: 'Delete {weld}? The registration is removed from the drawing and the weld log.',
        deleteHasData: 'The weld has production data ({status}) and cannot be deleted here.',
        decision: {
          rejected: 'Rejected by the office',
          approved: 'Approved by the office'
        },
        notifications: 'Notifications',
        noNotifications: 'No notifications',
        status: {
          pending: 'Field-registered',
          approved: 'Approved',
          rejected: 'Rejected'
        },
        sub: {
          pending: 'awaiting office approval',
          approved: 'field-registered · approved',
          rejected: 'rejected by the office',
          local: 'waiting for sync'
        },
        reasons: {
          missed_in_mapping: 'Missed in mapping',
          unforeseen_pipe_joint: 'Unforeseen pipe joint',
          site_change: 'Site change',
          other: 'Other'
        },
        joints: {
          BW: 'BW – Butt weld',
          FW: 'FW – Fillet weld',
          'BW-ROR': 'BW – Pipe joint'
        },
        grooves: {
          V: 'V-groove',
          X: 'X-groove',
          I: 'I-groove',
          U: 'U-groove',
          HV: 'HV-groove',
          J: 'J-groove',
          FILLET_A: 'Fillet (a-dimension)'
        },
        notif: {
          field_weld_registered: '{weld} registered in the field — review needed',
          field_weld_approved: '{weld} approved by the office',
          field_weld_rejected: '{weld} rejected by the office'
        }
      },
      // WIT-IMPL-M101-PWA-001: read-only NDT context per joint (server-derived)
      // and the hold-welding warning carrier. Never a block.
      ndtContext: {
        title: 'NDT context',
        classDefault: 'Class',
        classM101: 'Inspection category (NORSOK N-004)',
        classM601: 'NDT group (NORSOK M-601 table 2)',
        jointType: 'Joint type',
        weldType: 'Weld type',
        penDepth: 's (mm)',
        holdTime: 'Hold time before NDT',
        earliestNdt: 'Earliest NDT',
        pending: 'To be clarified',
        status: 'Status',
        hold: {
          pwht: 'none (NDT after PWHT)',
          default_48: '48 h',
          smys_le_355: '24 h (SMYS ≤ 355, documented)',
          smys_le_460_thin: '24 h (SMYS ≤ 460 and t < 40 mm, documented)',
          smys_missing: '48 h (yield strength missing)',
          thickness_missing: '48 h (thickness missing)',
          // WIT-FIX-M101-001: table G.1 fixed hold; no SMYS because the material is unlinked.
          g1_fixed_48: '48 val. (10.1)',
          material_unlinked: '48 val. – medžiaga nesusieta su standartine medžiaga',
          // WIT-IMPL-SVV-R761-002: NS-EN 1090-2 table 23 (SVV R761).
          table23: '{h} val. (NS-EN 1090-2 23 lentelė)',
          table23_cooling: 'tik aušinimas (23 lentelė)',
          table23_pending: 'reikia patikslinti (23 lentelė)',
          drawing: '{h} h (drawing)',
          default: '{h} h',
          none: 'none registered'
        }
      },
      weldingHold: {
        flag: 'Welding hold',
        wps: 'Welding hold on WPS {wps}',
        welder: 'Welding hold for the welder',
        since: 'since {date}',
        notBlocking: 'Warning – the weld can be registered, the office has been notified.'
      },
      pendingSync: 'Laukia sinchronizavimo',
      noSymbol: 'Trūksta simbolio',
      noExecution: 'Vykdymas dar neužregistruotas',
      close: 'Uždaryti',
      noDrawingFile: 'Brėžinys neįkeltas',
      noPreview: 'Peržiūra negalima',
      imageFailed: 'Nepavyko įkelti brėžinio vaizdo',
      roles: {
        fitter: 'Surinkėjas',
        welder: 'Suvirintojas',
        vt: 'VT kontrolė'
      },
      hints: {
        fitter: '{n} siūlės laukia surinkimo',
        fitterDone: 'Visi surinkimai atlikti!',
        welder: '{n} paruošta virinti',
        welderNone: 'Nėra paruoštų — laukiama surinkimo',
        welderNdt: 'Visos siūlės suvirintos — {n} laukia NDT tikrinimo',
        welderDone: 'Visos siūlės suvirintos ir patikrintos!',
        vt: '{n} laukia VT kontrolės',
        vtDone: 'Niekas nelaukia VT — viskas patikrinta!',
        vtNdtOpen: '{n} VT patvirtinta — laukia kitų NDT metodų (pasirašoma svetainėje)'
      },
      materials: 'Medžiagų atsekamumas',
      heat: 'Lydinio Nr.',
      heatMissing: 'Trūksta lydinio Nr.',
      bulkFitUp: 'Surinkta',
      bulkWeldEnd: 'Suvirinta',
      bulkWeldList: 'Pasirašo šias siūles',
      changeHistory: 'Pakeitimų istorija',
      auditField: {
        fillerBatch: 'Suvirinimo partija',
        batchPf: 'Surinkimo partija',
        filler: 'Priedas',
        certificateRefs: 'Suvirinimo sertifikatas',
        assemblyPf: 'Surinkimo sertifikatas',
        vtLevel: 'VT lygis',
        // WIT-FIX-CERT-5348-001 F2: the certificate decision in Endringslogg.
        certVerdict: 'Sertifikato patikra',
        certOverrideReason: 'Nepaisymo priežastis',
        certUnqualifiedSign: 'Pasirašyta be tinkamo sertifikato',
        traceabilityGaps: 'Pasirašyta trūkstant atsekamumo',
        certRegisteredLater: 'Sertifikatas užregistruotas vėliau'
      },
      auditFrom: 'Iš',
      auditTo: 'Į',
      auditNoChange: 'Išsaugota be pakeitimų',
      auditAction: {
        add: 'Pridėta',
        flag: 'Pažymėta',
        update: 'Pakeista',
        delete: 'Pašalinta'
      },
      posLabel: 'Poz.',
      posNrMissing: 'Trūksta poz. Nr.',
      noMaterials: 'Plane nėra medžiagų',
      addMaterial: 'Pridėti',
      newMaterial: 'Nauja medžiaga',
      editMaterial: 'Redaguoti medžiagą',
      materialHint: 'Nuskaitykite žymą ant plieno arba įveskite rankiniu būdu.',
      scanQr: 'Nuskaityti etiketę (QR)',
      scanNfc: 'RFID/NFC',
      scanComingNext: 'Nuskaitymas bus pridėtas vėliau — įveskite rankiniu būdu',
      orManual: 'ARBA ĮVESKITE RANKINIU BŪDU',
      materialType: 'Medžiagos tipas',
      selectType: 'Pasirinkite medžiagos tipą',
      editFieldHint: 'Išsaugomi tik pakeisti laukai. Parašas, data ir VT nekeičiami.',
      noTypeMatches: 'Atitikmenų nėra',
      noTypesInRegister: 'Registre nėra medžiagų tipų',
      heatNo: 'Lydinio Nr.',
      heatTypeNew: 'Kitas… (įveskite naują lydinio Nr.)',
      heatFromMaterialList: 'Iš medžiagų sąrašo',
      thickness: 'Storis (mm)',
      posNo: 'Pozicijos Nr.',
      saveChanges: 'Išsaugoti pakeitimus',
      gapWarnTitle: 'Trūksta duomenų',
      gapWarnHint: 'Šioje sandūroje trūksta medžiagos atsekamumo duomenų. Vis tiek pasirašyti?',
      gapWarnYes: 'Taip, pasirašyti',
      gapWarnNo: 'Ne, užpildyti dabar',
      gapThickness: 'nėra storio',
      gapType: 'nėra medžiagos tipo',
      gapRow: '{n} eilutė',
      bulkSignVt: 'VT patvirtinti visas {n}',
      bulkConfirm: 'Patvirtinti',
      bulkTitleVt: 'VT patvirtinti visas paruoštas siūles',
      bulkHint: 'Patvirtina {n} siūles, kurios šiame brėžinyje laukia VT. Trūkstami duomenys parodomi vėliau.',
      bulkSigned: 'pasirašyta: {n}',
      bulkSkipped: 'praleista: {n}',
      bulkGapsTitle: 'Atsekamumo trūkumai',
      bulkGapsHint: 'Šiose siūlėse trūksta duomenų. Galite vis tiek patvirtinti arba atšaukti ir pirma juos užpildyti.',
      gapHeat: 'nėra lydymo nr.',
      gapPosNr: 'nėra pozicijos nr.',
      gapNoMaterials: 'nėra medžiagų',
      cancel: 'Atšaukti',
      removeMaterial: 'Pašalinti medžiagą',
      saving: 'Saugoma…',
      repairNote: 'VT atmetė šią siūlę — pataisykite ir užregistruokite iš naujo.',
      actFitUp: 'Surinkimas atliktas',
      actWeld: 'Suvirinta',
      actRepair: 'Suremontuota ir suvirinta',
      actVtOk: 'VT patvirtinta — lygis {level}',
      actVtReject: 'Atmesti — siųsti remontui',
      actionsComingNext: 'Registracija bus prijungta kitame etape',
      vtSignedNdtOpen: 'VT patvirtinta — kiti NDT dar neatlikti',
      noAction: 'Nėra {role} veiksmo šiai siūlei ({status})'
    },
    advancedWeldLog: {
      // 5183 / R-2.7c: the production-series column in the weld list.
      spoolNo: 'Ritinio / dalies nr.',
      // 5183 / R-2.7d: route to the weld-mapping screen, where the flow lives.
      addFieldWeld: 'Pridėti siūlę vietoje',
      noDrawingsFound: 'Brėžinių nerasta',
      folderLIst: 'Aplankų sąrašas',
      projectDrawings: 'Projekto brėžiniai',
      drawingNumber: 'Brėžinio numeris',
      weldCount: 'Suvirinimų skaičius',
      engineering: 'Inžinerija',
      production: 'Gamyba',
      ndt: 'NDT',
      pending: 'Laukiama',
      inProgress: 'Vykdoma',
      completed: 'Užbaigta',
      ndtFaultScope: 'NDT defektų sritis',
      submit: 'Pateikti',
      cancel: 'Atšaukti',
      newWeldLog: 'Suvirinimo žurnalas',
      updateWeldLog: 'Atnaujinti žurnalą',
      weldNo: 'Suvirinimo nr.',
      jointType: 'Jungties tipas',
      wps: 'WPS',
      weldingConsumables: 'Suvirinimo medžiagos',
      batchNumber: 'Heat / Batch nr',
      welderCertificates: 'Suvirintojo sertifikatai',
      weldEnd: 'Suvirinimo pabaiga',
      ok: 'Gerai',
      sign: 'Pasirašyti',
      comments: 'Komentarai',
      notAcceptable: 'Nepriimtina',
      fault: 'Defektas',
      noResultsFound: 'Rezultatų nerasta.',
      drawing: 'Brėžinys',
      projectName: 'Projekto pavadinimas',
      aoRanked: 'AO reitinguotas',
      poRanked: 'PO reitinguotas',
      searchWeldLogs: 'Ieškoti suvirinimo žurnalų',
      confirmWeldLogDelete: 'Ar tikrai norite pašalinti suvirinimą {weld_nr}?',
      weldingProcess: 'Suvirinimo procesas',
      ndts: 'NDT patikros',
      searchDrawings: 'Ieškoti brėžinių',
      selectDrawing: 'Pasirinkite brėžinį',
      noWeldLogResultsFound: 'Suvirinimo žurnalų nerasta!',
      selectDrawingToLoadWeldLogs: 'Pasirinkite brėžinį, kad įkeltumėte žurnalus!',
      certificateRequiredWhenWeldEnd: 'Sertifikatas privalomas, kai pasirinkta Suvirinimo pabaiga.'
    }
  }
}
